import * as services from 'services/apiKeys';
import map from 'lodash/map';
import filter from 'lodash/filter';

export const SET_ERROR = 'apiKeys/SET_ERROR';
export const CLEAR_ERROR = 'apiKeys/CLEAR_ERROR';
export const REQUEST_STARTED = 'apiKeys/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'apiKeys/REQUEST_SUCCESSFUL';
export const SET_API_KEYS = 'apiKeys/SET_API_KEYS';
export const SET_API_KEY = 'apiKeys/SET_API_KEY';
export const EDIT_API_KEY = 'apiKeys/EDIT_API_KEY';
export const GET_API_KEYS_FROM_SERVER = 'apiKeys/GET_API_KEYS_FROM_SERVER';
export const DELETE_API_KEY = 'apiKeys/DELETE_API_KEY';
export const ADD_API_KEY = 'apiKeys/ADD_API_KEY';
export const SET_CREATED_KEY = 'apiKeys/SET_CREATED_KEY';
export const REMOVE_CREATED_KEY = 'apiKeys/REMOVE_CREATED_KEY';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};

export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});

export const setCreatedKey = apiKey => ({
  type: SET_CREATED_KEY,
  apiKey,
});

const replaceKeys = keys =>
  map(keys, key => ({
    id: key.api_key_id,
    name: key.api_key_name,
    projectId: key.project_id,
    can_unsubscribe: key.can_unsubscribe,
  }));

export const setApiKeys = keys => ({
  type: SET_API_KEYS,
  keys: replaceKeys(keys),
});

export const getApiKeysFromServer = () => dispatch => {
  dispatch(requestStarted());
  services
    .getApiKeys()
    .then(keys => {
      dispatch(setApiKeys(keys));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(setError('Error fetching apiKeys'));
      dispatch(requestCompleted());
    });
};

export const createApiKey = ({
  name,
  projectId,
  template_types,
  can_unsubscribe,
}) => dispatch => {
  dispatch(requestStarted());
  services
    .createApiKey({ name, projectId, template_types, can_unsubscribe })
    .then(({ success, api_key: apiKey }) => {
      if (success) {
        dispatch(setCreatedKey(apiKey));
        dispatch(getApiKeysFromServer());
      } else dispatch(setError('Error fetching api'));
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const deleteApiKey = apiKeyId => dispatch => {
  dispatch(requestStarted());
  services
    .deleteApiKey(apiKeyId)
    .then(({ success }) => {
      if (success) dispatch(getApiKeysFromServer());
      else dispatch(setError('Error deleting API key'));
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

const getDeleteProjectPromises = (apiKeys, projectId) => {
  const projectApiKeys = filter(apiKeys, { projectId });
  return map(projectApiKeys, apiKey => services.deleteApiKey(apiKey.id));
};

export const delateProjectApiKeys = projectId => (dispatch, getStore) => {
  dispatch(requestStarted());
  const { apiKeys } = getStore().apiKeys;
  const promises = getDeleteProjectPromises(apiKeys, projectId);
  if (promises.length) {
    Promise.all(promises)
      .then(() => {
        dispatch(getApiKeysFromServer());
        dispatch(requestCompleted());
      })
      .catch(() => {
        dispatch(setError('Error deleting api keys'));
        dispatch(requestCompleted());
      });
  }
};

export const removeCreatedKey = () => ({
  type: REMOVE_CREATED_KEY,
});
